// extracted by mini-css-extract-plugin
export default {"Counters":"MatriculationCounters_Counters__QhpMh"};